/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramTransactionsUserControllerCancelMutationResponse,
  TelegramTransactionsUserControllerCancelPathParams,
  TelegramTransactionsUserControllerCancel401,
} from '../types/TelegramTransactionsUserControllerCancel.ts';

function getTelegramTransactionsUserCancelUrl(id: TelegramTransactionsUserControllerCancelPathParams['id']) {
  const res = { method: 'PATCH', url: `/api/user/telegram/transactions/cancel/${id}` as const };
  return res;
}

/**
 * {@link /api/user/telegram/transactions/cancel/:id}
 */
export async function telegramTransactionsUserCancel(
  id: TelegramTransactionsUserControllerCancelPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramTransactionsUserControllerCancelMutationResponse,
    ResponseErrorConfig<TelegramTransactionsUserControllerCancel401>,
    unknown
  >({ method: 'PATCH', url: getTelegramTransactionsUserCancelUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
